import HomePageImageContent from "@/components/elements/ImageWithContent/homepageimagecontent"
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent"
import aboutusPoster from "@/assets/images/about_quality_integrity-poster.webp"
import aboutusVideo from "@/assets/images/about_quality_integrity.mp4"

const About = () => {
  return (
  <>
    <div className="2xl:px-40 xl:px-35 lg:px-30 md:px-20 sm:px-5">
      <TitleWithContent title="About Us">
      </TitleWithContent>
      
      <HomePageImageContent
        title="Quality and Integrity"
        imageUrl={aboutusPoster}
        videoUrl={aboutusVideo}
        content={
        <>
        <span className="span-text">Sheel Waterproofing</span> has been at the forefront of the 
        waterproofing industry for over a decade. Founded by <span className="span-text">Mr. Shankar Karki</span>, our company began with a 
        vision to provide effective and reliable waterproofing solutions to protect properties from water damage. 
        With a team of skilled professionals and a commitment to innovation, we have grown into a trusted name in the industry. 
        Our journey continues as we strive to ensure dry and secure properties for all our valued clients.
        </>
        }
        />
      </div>
  </>
  )
}

export default About